import { permisions } from "@/onenetwork/constants/onenetwork.perm.const"
import { getFullAddress } from "@/utils/helper"
import moment from "moment"

export const accountStatus = (item: any) => {
  if (item.deleted_at !== null) {
    return [{type: 'danger', label: 'Đã khóa'}]
  } else {
    if (item.activation_status === true) {
      return [{type: 'success', label: 'Đang hoạt động'}]
    } else {
      return [{type: 'warn', label: 'Tạm ngưng'}]
    }
  }
}

export const accountType  = (type: string) => {
  return type === 'broker' ? 'Môi giới' : 'Tài khoản thường';
}

export const kycStatus = (item: any) => {
  if (item === null) {
    return [{type: 'secondary', label: 'Chưa KYC'}]
  }
  if (item?.processing_status === 'pending') {
    return [{type: 'warn', label: 'Đang KYC'}]
  } else if (item?.processing_status === 'approved') {
    return [{type: 'success', label: 'Đã KYC'}]
  } else if (item?.processing_status === 'rejected') {
    return [{type: 'danger', label: 'Từ chối KYC'}]
  }
}

export const formatTableDataAccount = (data: any[]) => {
  return data.map((item) => ({
    ...item,
    avatar: item?.avatar?.url?.thumbnail || '',
    account: {
      avatar: item?.avatar?.url?.thumbnail || '',
      phone: item?.phone_number || '',
      email: item?.email || '',
      full_name: item?.full_name || '',
    },
    birthday: item?.birthday ?? '-',
    address: getFullAddress(item?.province, item?.district, item?.ward),
    status: item.status === 'active' ? 'Hoạt động' : 'Ngừng hoạt động',
    account_status: accountStatus(item),
    account_type: accountType(item?.account_type),
    membership: item?.membership?.name || 'Chưa đăng ký gói',
    cash_balance: item?.wallet?.cash_balance || 0,
    point_balance: item?.wallet?.point_balance || 0,
    created_at: item.created_at ? item.created_at : '',
    kyc_status: kycStatus(item?.kyc_information),
    kyc_request_date: item?.kyc_information !== null ? item?.kyc_information?.updated_at : '',
  }));
}

export const formatTableDataKyc = (data: any) => {
  //convert data to array
  //check if data is array
  if (Array.isArray(data)) {
    if (data.length > 0) {
      return data.map((item) => ({
        ...item,
        code: item?.user?.code || '',
        avatar: item?.avatar?.url?.thumbnail || '',
        phone: item.user?.phone_number || '',
        email: item?.user?.email || '',
        full_name: item?.full_name || '',
        address: getFullAddress(item?.province, item?.district, item?.ward),
        kyc_request_date: item.kyc_request_date ? item.kyc_request_date : '',
      }));
    }else{
      return []
    }
  }
  //check if data is object
  if (typeof data === 'object') {
    const birthday = moment(data?.birthday, "DD-MM-YYYY").format('YYYY-MM-DD HH:mm:ss') || ''
    return {
      id: data?.id || null,
      user_id: data?.user?.id || null,
      code: data?.user?.code || '',
      birthday: data?.birthday ? moment(data?.birthday, "DD-MM-YYYY").format('YYYY-MM-DD HH:mm:ss') : '',
      full_name: data?.user?.full_name || '',
      address: data?.user?.ward?.name ? `${data?.user?.address || ''}, ${data.user.ward.name}, ${data.user.district.name}, ${data.user.province.name}` : '',
      region: data?.ward?.name ? `${data.ward.name}, ${data.district.name}, ${data.province.name}` : '',
      front_image_url: data?.front_id_image?.url?.original || '',
      back_image_url: data?.back_id_image?.url?.original || '',
      selfie_image_url: data?.selfie_image?.url?.original || '',
      front_id_image: data?.front_id_image?.uuid || '',
      back_id_image: data?.back_id_image?.uuid || '',
      selfie_image: data?.selfie_image?.uuid || '',
      kyc_status_label: kycStatus(data),
      issue_date: data?.issue_date ? moment(data?.issue_date, "DD-MM-YYYY").format('YYYY-MM-DD HH:mm:ss') : '',
      issue_place: data?.issue_place || '',
      national_id_number: data?.national_id_number || '',
      kyc_request_date: data?.kyc_request_date || '',
      activation_status: data?.user?.activation_status || false,
      expiration_date: data?.expiration_date || '',
      province_id: data?.province_id || null,
      district_id: data?.province_id || null,
      ward_id: data?.province_id || null,
    }
  }
}

const getPermissionNames = (keys: string[]) => {
  type PermissionsType = typeof permisions;
  if (!keys || keys.length === 0) return '-';
  return keys.map(key => {
    const [group, child] = key.split(".");
    const groupData = permisions[group as keyof PermissionsType];
    const childData = groupData?.child?.[child as keyof typeof groupData.child];
    return childData?.name ?? "-";
  });
}

const getStatusAccountBO = (item: any) => {
  if (item.activation_status === true && item.deleted_at === null) {
    return [{type: 'success', label: 'Đang hoạt động'}]
  } else if (item.activation_status === false && item.deleted_at === null) {
    return [{type: 'warn', label: 'Tạm ngưng'}]
  } else {
    return [{type: 'danger', label: 'Đã khóa'}]
  }
}

export const formatTableDataBo = (data: any[]) => {
  //convert data to array
  return data.map((item) => ({
    ...item,
    code: item.code || '',
    avatar: item?.avatar?.url?.thumbnail || '',
    phone: item?.phone_number || '',
    email: item?.email || '',
    full_name: item?.full_name || '',
    perms: item?.permissions?.length > 0 ? item.permissions.length : '-',
    created_by: item?.author?.full_name || '-',
    created_at: item.created_at ? item.created_at : '',
    status: getStatusAccountBO(item)
  }));
}

export const formatTableDataReferral = (data: any[]) => {
  //convert data to array
  return data.map((item) => ({
    ...item,
    code: item?.code || '',
    avatar: item?.avatar?.url?.thumbnail || '',
    phone: item?.phone_number || '',
    email: item?.email || '',
    full_name: item?.full_name || '',
    created_at: item.created_at ? item.created_at : '',
  }));
}

